export const FORBIDDEN_NAMES = ['self', 'n/a', 'none', 'retired', 'na', 'nope', 'personal', 'n-a', 'no business', 'not a business', 'not available', 'not applicable'];
